(function () {
  function initBrand(scope) {
    var root = scope || document;

    root.querySelectorAll('.jarn-reveal:not([data-jarn-reveal-ready])').forEach(function (element) {
      element.dataset.jarnRevealReady = 'true';

      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        element.classList.add('is-visible');
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      observer.observe(element);
    });
  }

  function updateHeader() {
    document.documentElement.classList.toggle('jarn-page-scrolled', window.scrollY > 18);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBrand(document);
      updateHeader();
    });
  } else {
    initBrand(document);
    updateHeader();
  }

  window.addEventListener('scroll', updateHeader, { passive: true });
  document.addEventListener('shopify:section:load', function (event) {
    initBrand(event.target);
  });
})();
